"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSelectedValueSampleNature = exports.InitSampleNature = exports.SampleNaturesLoaded = exports.cbSampleNature = exports.methodsRestricted = void 0;
var Aanvraag = require("../Aanvraag");
var Algemeen = require("../Algemeen");
var Methodes = require("../AanvraagMethodes/Methodes");
var ComboBox = require("../Combobox");
var SampleNaturesAll;
var SampleNatureFavoritesAll;
var CallWebServiceGetSampleNaturesComplete = false;
var CallWebServiceGetSampleNatureFavoritesComplete = false;
var monitor = true;
exports.SampleNaturesLoaded = false;
var previousSampleNature;
//INIT
function InitSampleNature(monitoring) {
    monitor = monitoring;
    var tbSampleNature = $('#ctl00_cphBody_tbSampleNature');
    var pnlSampleNature = $('#ctl00_cphBody_pnlSampleNature');
    exports.cbSampleNature = new ComboBox.ComboBox(tbSampleNature, pnlSampleNature, FilterAndFillSampleNature, TextboxValueOnBlur, 'divDropDownItem', 'divDropDownItemInFocus');
    var mycbSampleNature = exports.cbSampleNature;
    //Monitor samplenaturetextbox for changes by combobox
    previousSampleNature = mycbSampleNature.selectedValue;
    if (monitor)
        setInterval(function () {
            if (mycbSampleNature.selectedValue !== previousSampleNature) {
                previousSampleNature = mycbSampleNature.selectedValue;
                for (var i = 0; i < SampleNaturesAll.length - 1; i++) {
                    if (SampleNaturesAll[i].Code === previousSampleNature) {
                        exports.methodsRestricted = [];
                        Methodes.MarkRestrictedMethods('tableMethods');
                        Methodes.MarkRestrictedMethods('tableMethodsFavorites');
                    }
                }
            }
        }, 500);
    //Algemeen.PopupControl(tbSampleNature, pnlSampleNature);
    Algemeen.CallWebServiceGetGeneric('GetSampleNatures', OnSuccessGetSampleNatures);
    Algemeen.CallWebServiceGetGeneric('GetSampleNatureFavorites', OnSuccessGetSampleNatureFavorites);
}
exports.InitSampleNature = InitSampleNature;
//GET DATA
function OnSuccessGetSampleNatures(data, status) {
    Algemeen.CheckSessionTimeout(data);
    SampleNaturesAll = data.d;
    if (Aanvraag.EditMode) {
        SetSelectedValueSampleNature(Aanvraag.AanvraagObj.SampleNature);
    }
    CallWebServiceGetSampleNaturesComplete = true;
    if (CallWebServiceGetSampleNatureFavoritesComplete) {
        //fillDropDownSampleNature(SampleNatureFavoritesAll, SampleNaturesAll, cbSampleNature.$pnl);
        exports.SampleNaturesLoaded = true;
        if (monitor)
            Aanvraag.CheckAllLoaded();
    }
}
function OnSuccessGetSampleNatureFavorites(data, status) {
    Algemeen.CheckSessionTimeout(data);
    SampleNatureFavoritesAll = data.d;
    CallWebServiceGetSampleNatureFavoritesComplete = true;
    if (CallWebServiceGetSampleNaturesComplete) {
        //fillDropDownSampleNature(SampleNatureFavoritesAll, SampleNaturesAll, cbSampleNature.$pnl);
        exports.SampleNaturesLoaded = true;
        if (monitor)
            Aanvraag.CheckAllLoaded();
    }
}
//FILTER DATA
function FilterAndFillSampleNature(cb) {
    if ((CallWebServiceGetSampleNatureFavoritesComplete) && (CallWebServiceGetSampleNaturesComplete)) {
        //Only show all samplenatures when more then 2 chars are type
        var SampleNatures = new Array;
        if (cb.$tb.val().length > 1)
            SampleNatures = FilterSampleNature(SampleNaturesAll, cb.$tb.val());
        var SampleNatureFavorites = FilterSampleNature(SampleNatureFavoritesAll, cb.$tb.val());
        //if ((cb.$tb.val().length < 1) || (SampleNatures.length == 0) && (SampleNatureFavorites.length == 0)) {
        if ((SampleNatures.length == 0) && (SampleNatureFavorites.length == 0)) {
            cb.hidePopup();
            return;
        }
        else {
            cb.showPopup();
        }
        fillDropDownSampleNature(SampleNatureFavorites, SampleNatures, cb.$pnl);
    }
}
function FilterSampleNature(SampleNatures, filter) {
    var filteredSampleNatures = new Array();
    for (var i = 0; i < SampleNatures.length; i++) {
        var SampleNature = SampleNatures[i];
        if (SampleNature.Description.toLowerCase().indexOf(filter.toLowerCase()) != -1) {
            filteredSampleNatures.push(SampleNature);
        }
    }
    return filteredSampleNatures;
}
function TextboxValueOnBlur(tbValue) {
    for (var i = 0; i < SampleNaturesAll.length; i++) {
        var SampleNature = SampleNaturesAll[i];
        if (SampleNature.Description.toLowerCase() == tbValue.toLowerCase()) {
            return SampleNature;
        }
    }
    return '';
}
//DROPDOWN
function fillDropDownSampleNature(SampleNatureFavorites, SampleNatures, $pnl) {
    $pnl.empty();
    for (var i = 0; i < SampleNatureFavorites.length; i++) {
        AddSampleNatureFavorite(SampleNatureFavorites[i], i, $pnl);
    }
    if (SampleNatureFavorites.length > 0) {
        $pnl.append($('<div class=""><hr/></div>'));
    }
    for (var i = 0; i < SampleNatures.length; i++) {
        AddSampleNature(SampleNatures[i], i, $pnl);
    }
}
function AddSampleNature(SampleNature, i, $pnl) {
    var $div = $('<div id="divSampleNature' + i + '" class="divDropDownItem">' + SampleNature.Description + GetDivAccordingToLegislation(SampleNature) + '</div>');
    AddItemToPnl(SampleNature, $div, $pnl);
}
function AddSampleNatureFavorite(SampleNature, i, $pnl) {
    var $div = $('<div id="divSampleNatureFavorite' + i + '" class="divDropDownItem divSampleNatureFavorite">' + SampleNature.Description + GetDivAccordingToLegislation(SampleNature) + '</div>');
    AddItemToPnl(SampleNature, $div, $pnl);
}
function GetDivAccordingToLegislation(SampleNature) {
    if (SampleNature.AccordingToLegislation) {
        return '<img class="imgLegislation" src="images/Legislation.gif" />';
    }
    return '';
}
function AddItemToPnl(SampleNature, $div, $pnl) {
    $div.click(function () { exports.cbSampleNature.pnlOnClick(SampleNature.Code, SampleNature.Description); });
    $div.mouseover(function () { exports.cbSampleNature.pnlOnMouseover(this); });
    $pnl.append($div);
}
function SetSelectedValueSampleNature(value) {
    exports.cbSampleNature.selectedValue = value;
    for (var i = 0; i < SampleNaturesAll.length; i++) {
        if (SampleNaturesAll[i].Code == value) {
            exports.cbSampleNature.$tb.val(SampleNaturesAll[i].Description);
            break;
        }
    }
}
exports.SetSelectedValueSampleNature = SetSelectedValueSampleNature;
